import { SubCategoryRepository } from '../../domain/repositories/sub-category.repository';
import { SubCategoryEntity } from '../../domain/entities/sub-category.entity';

export class ToggleSubCategoryStatusUseCase {
  constructor(private readonly subCategoryRepository: SubCategoryRepository) {}

  async execute(id: string, status: boolean): Promise<SubCategoryEntity> {
    return this.subCategoryRepository.toggleSubCategoryStatus(id, status);
  }
}
